// -- PREORDER, ADD TO CART, AND SOLD OUT
document.addEventListener("DOMContentLoaded", function () {
  // 🔧 Add your sold-out variant/product IDs here
  const SOLD_OUT_VARIANT_IDS = []; // replace with real variant IDs
  const SOLD_OUT_PRODUCT_IDS = []; // replace with real product IDs

  function updateButton() {
    const variantInput = document.querySelector("input[name='id']");
    const variantId = variantInput?.value;
    const productForm = document.querySelector("product-form");
    const addToCartButton = productForm?.querySelector("[name='add']");
    const deliveryWidget = document.querySelector(".delivery-widget__theme");

    if (!variantId || !productForm || !addToCartButton) {
      console.warn("Missing elements for PREORDER logic.");
      return;
    }

    const productTag = productForm.dataset.productTag?.toUpperCase() || "";
    const variantTagEl = document.querySelector(`.variant-metafield[data-variant-id='${variantId}']`);
    const variantTag = variantTagEl?.dataset.variantTag?.toUpperCase() || "";
    const productId = productForm.dataset.productId;

    const isSoldOut = SOLD_OUT_VARIANT_IDS.includes(variantId) || SOLD_OUT_PRODUCT_IDS.includes(productId);
    const isPreorder = variantTag === "PREORDER" || productTag === "PREORDER";

    if (isSoldOut) {
      addToCartButton.innerHTML = "SOLD OUT";
      addToCartButton.disabled = true;
      if (deliveryWidget) deliveryWidget.style.display = "none";
      return;
    }

    addToCartButton.innerHTML = isPreorder ? "Pre-Order Now" : "Add to Cart +";
    addToCartButton.disabled = false;

    const actualForm = addToCartButton.closest("form");
    if (actualForm) {
      actualForm.setAttribute("action", "/cart/add");
    }

    if (deliveryWidget) {
      deliveryWidget.style.display = isPreorder ? "none" : "";
    }
  }

  updateButton();

  document.addEventListener("change", function (event) {
    if (event.target.name === "id") {
      updateButton();
    }
  });

  document.addEventListener("click", function (event) {
    const addToCartButton = event.target.closest("[name='add']");
    if (addToCartButton && !addToCartButton.disabled) {
      event.preventDefault();
      const form = addToCartButton.closest("form");
      if (form) form.submit();
    }
  });
});

// -- REVERT TO THIS IF SOMETHING GOES WRONG --
// document.addEventListener("DOMContentLoaded", function () {
//   function updateButton() {
//     const variantInput = document.querySelector("input[name='id']");
//     const variantId = variantInput?.value;
//     const productForm = document.querySelector("product-form");
//     const addToCartButton = productForm?.querySelector("[name='add']");
//     const deliveryWidget = document.querySelector(".delivery-widget__theme");

//     if (!variantId || !productForm || !addToCartButton) {
//       console.warn("Missing elements for PREORDER logic.");
//       return;
//     }

//     const productTag = productForm.dataset.productTag?.toUpperCase() || "";
//     const variantTagEl = document.querySelector(`.variant-metafield[data-variant-id='${variantId}']`);
//     const variantTag = variantTagEl?.dataset.variantTag?.toUpperCase() || "";

//     console.log("Variant ID:", variantId);
//     console.log("Variant Tag:", variantTag);
//     console.log("Product Tag:", productTag);

//     const isPreorder = variantTag === "PREORDER" || productTag === "PREORDER";

//     addToCartButton.innerHTML = isPreorder ? "PRE-ORDER & SAVE" : "ADD TO CART";

//     // Ensure form submission works
//     const actualForm = addToCartButton.closest("form");
//     if (actualForm) {
//       actualForm.setAttribute("action", "/cart/add");
//     }

//     // 👉 Hide or show delivery widget
//     if (deliveryWidget) {
//       deliveryWidget.style.display = isPreorder ? "none" : "";
//     }
//   }

//   // Run on initial page load
//   updateButton();

//   // Watch for variant changes (e.g. swatches or dropdowns)
//   document.addEventListener("change", function (event) {
//     if (event.target.name === "id") {
//       updateButton();
//     }
//   });

//   // Handle click to make sure form submits
//   document.addEventListener("click", function (event) {
//     const addToCartButton = event.target.closest("[name='add']");
//     if (addToCartButton) {
//       event.preventDefault();
//       const form = addToCartButton.closest("form");
//       if (form) form.submit();
//     }
//   });
// });
